import type { RouteLocation } from 'vue-router';
import { AppRouteRecordRaw } from '../types';

const Body = () => import('@/components/body.vue');
const IntegrationOverview = () =>
  import('@/pages/integrationguide/integrationOverview/IntegrationOverview.vue');
const DeeplinkRegistrationApiGettingStarted = () =>
  import('@/pages/integrationguide/deeplinkingregistration/GettingStarted.vue');
const DeeplinkRegistrationApiReference = () =>
  import('@/pages/integrationguide/deeplinkingregistration/ApiReference.vue');
const WebappIntegrationIntroduction = () =>
  import('@/pages/integrationguide/webappIntegration/Introduction.vue');
const WebappIntegrationGettingStarted = () =>
  import('@/pages/integrationguide/webappIntegration/GettingStarted.vue');
const WebappIntegrationTopupFlowSteps = () =>
  import('@/pages/integrationguide/webappIntegration/TopupFlowSteps.vue');
const WebappIntegrationTesting = () =>
  import('@/pages/integrationguide/webappIntegration/Testing.vue');
const SdkIntroduction = () => import('@/pages/integrationguide/rydsdk/SdkIntroduction.vue');
const SdkInstallation = () =>
  import('@/pages/integrationguide/rydsdk/gettting-started/installation.vue');
const TopupApiReference = () =>
  import('@/pages/integrationguide/rydpayapis/api-reference/ApiReference.vue');
const RydPayApiGettingStarted = () =>
  import('@/pages/integrationguide/rydpayapis/getting-started/GettingStarted.vue');
const RydPayApiApiFundamentals = () =>
  import('@/pages/integrationguide/rydpayapis/guides-general/api-fundamentals/ApiFundamentals.vue');
const RydPayApiBestPractices = () =>
  import('@/pages/integrationguide/rydpayapis/guides-general/best-practices/BestPractices.vue');
const RydPayApiIntegrationPathways = () =>
  import('@/pages/integrationguide/rydpayapis/integration-pathways/IntegrationPathways.vue');
const RydPayApiPrepayAndPostpay = () =>
  import('@/pages/integrationguide/rydpayapis/guides-fuelling/prepay-and-postpay/PrepayAndPostpay.vue');
const RydPayApiPrepayAndPostpayV2025 = () =>
  import('@/pages/integrationguide/rydpayapis/guides-fuelling/prepay-and-postpay-v2025/PrepayAndPostpayV2025.vue');
const FuellingPostmanCollectionViewer = () =>
  import('@/pages/integrationguide/rydpayapis/guides-fuelling/postman-collection-viewer/FuellingPostmanCollectionViewer.vue');
const FuellingSimulatedStations = () =>
  import('@/pages/integrationguide/rydpayapis/guides-fuelling/fuelling-simulated-stations/FuellingSimulatedStations.vue');
const FuellingTestScenarios = () =>
  import('@/pages/integrationguide/rydpayapis/guides-fuelling/fuelling-test-scenarios/FuellingTestScenarios.vue');
const FuellingClientFlow = () =>
  import('@/pages/integrationguide/rydpayapis/guides-fuelling/fuelling-client-flow/FuellingClientFlow.vue');
const FuellingClientFlowDetailed = () =>
  import('@/pages/integrationguide/rydpayapis/guides-fuelling/fuelling-client-flow/FuellingClientFlow.vue');
const CarWashTestScenarios = () =>
  import('@/pages/integrationguide/rydpayapis/guides-car-wash/car-wash-test-scenarios/CarWashTestScenarios.vue');
const CarWashSimulatedStations = () =>
  import('@/pages/integrationguide/rydpayapis/guides-car-wash/car-wash-simulated-stations/CarWashSimulatedStations.vue');
const CarWashClientFlow = () =>
  import('@/pages/integrationguide/rydpayapis/guides-car-wash/car-wash-client-flow/CarWashClientFlow.vue');
const CarWashPlayground = () =>
  import('@/pages/integrationguide/rydpayapis/guides-car-wash/CarWashPlayground.vue');
const EvPricing = () =>
  import('@/pages/integrationguide/rydpayapis/guides-ev-charging/ev-charging-pricing/EvPricing.vue');
const EvInsightsAndStatistics = () =>
  import('@/pages/integrationguide/rydpayapis/guides-ev-charging/EvInsightsAndStatistics.vue');
const EVChargingApiJourney = () =>
  import('@/pages/integrationguide/rydpayapis/guides-ev-charging/EVChargingApiJourney.vue');
const EvChargingTestScenarios = () =>
  import('@/pages/integrationguide/rydpayapis/guides-ev-charging/ev-charging-test-scenarios/EvChargingTestScenarios.vue');
const EvChargingSimulatedStations = () =>
  import('@/pages/integrationguide/rydpayapis/guides-ev-charging/ev-charging-simulated-stations/EvChargingSimulatedStations.vue');
const RydPayApiOrderStateManagement = () =>
  import('@/pages/integrationguide/rydpayapis/guides-general/order-state-management/OrderStateManagement.vue');
const RydPayApiOrderTimeouts = () =>
  import('@/pages/integrationguide/rydpayapis/guides-general/order-timeouts-and-cancellation/OrderTimeoutsAndCancellation.vue');
const RydPayApiActionCodesOverview = () =>
  import('@/pages/integrationguide/rydpayapis/action-codes/overview/ActionCodesOverview.vue');
const RydPayApiActionCodesPop = () =>
  import('@/pages/integrationguide/rydpayapis/action-codes/pop/ActionCodesPop.vue');
const RydPayApiActionCodesPay = () =>
  import('@/pages/integrationguide/rydpayapis/action-codes/pay/ActionCodesPay.vue');
const RydPayApiActionCodesSearch = () =>
  import('@/pages/integrationguide/rydpayapis/action-codes/search/ActionCodesSearch.vue');
const RydPayApiActionCodesSolutions = () =>
  import('@/pages/integrationguide/rydpayapis/action-codes/solutions/ActionCodesSolutions.vue');
const PartnerWalletOverview = () =>
  import('@/pages/integrationguide/partner-wallet/overview/PartnerWalletOverview.vue');
const RydPayApiFAQs = () =>
  import('@/pages/integrationguide/rydpayapis/support-and-resources/faqs/Faqs.vue');
const RydPayApiTermsAndDefinitions = () =>
  import('@/pages/integrationguide/rydpayapis/support-and-resources/terms-and-definitions/TermsAndDefinitions.vue');
const RydPayApiReleaseNotesAndUpdates = () =>
  import('@/pages/integrationguide/rydpayapis/release-notes-and-updates/ReleaseNotesAndUpdates.vue');
const RydPayApiTroubleshootingAndSupport = () =>
  import('@/pages/integrationguide/rydpayapis/support-and-resources/TroubleshootingAndSupport.vue');
const TestingAndSimulation = () =>
  import('@/pages/integrationguide/rydpayapis/guides-general/testing-and-simulation/TestingAndSimulation.vue');
const KeyConcepts = () =>
  import('@/pages/integrationguide/rydpayapis/guides-general/key-concepts/KeyConcepts.vue');
const PlacesFilteringGuide = () =>
  import('@/pages/integrationguide/rydpayapis/guides-general/places-filtering-guide/PlacesFilteringGuide.vue');
const FleetApiIntroduction = () =>
  import('@/pages/integrationguide/fleet-apis/FleetApiIntroduction.vue');
const FleetApiAuthentication = () =>
  import('@/pages/integrationguide/fleet-apis/FleetApiAuthentication.vue');
const FleetApiReference = () => import('@/pages/integrationguide/fleet-apis/FleetApiReference.vue');
const FleetApiAppLogin = () =>
  import('@/pages/integrationguide/fleet-apis/app-login/FleetApiAppLogin.vue');
const RydConnectOverview = () =>
  import('@/pages/integrationguide/ryd-connect/getting-started/Overview.vue');
const RydConnectIntegrationPathways = () =>
  import('@/pages/integrationguide/ryd-connect/getting-started/IntegrationPathways.vue');
const RydConnectAuthenticationOverview = () =>
  import('@/pages/integrationguide/ryd-connect/authentication/AuthenticationOverview.vue');
const RydConnectSessionToken = () =>
  import('@/pages/integrationguide/ryd-connect/authentication/SessionToken.vue');
const RydConnectJwtAssertion = () =>
  import('@/pages/integrationguide/ryd-connect/authentication/JwtAssertion.vue');
const RydConnectOneTimeTokenSecurity = () =>
  import('@/pages/integrationguide/ryd-connect/authentication/OneTimeTokenSecurity.vue');
const RydConnectPartnerExtraData = () =>
  import('@/pages/integrationguide/ryd-connect/payload/PartnerExtraData.vue');
const RydConnectDeveloperResources = () =>
  import('@/pages/integrationguide/ryd-connect/testing/DeveloperResources.vue');
const RydConnectCallbacks = () =>
  import('@/pages/integrationguide/ryd-connect/app-integration/Callbacks.vue');
const RydConnectTheming = () =>
  import('@/pages/integrationguide/ryd-connect/app-integration/Theming.vue');
const RydConnectTesting = () => import('@/pages/integrationguide/ryd-connect/testing/Testing.vue');
const RydConnectWebViewApproaches = () =>
  import('@/pages/integrationguide/ryd-connect/getting-started/WebViewApproaches.vue');
const RydConnectSimulatedStations = () =>
  import('@/pages/integrationguide/ryd-connect/testing/SimulatedStations.vue');
const RydConnectSkipTheMap = () =>
  import('@/pages/integrationguide/ryd-connect/payload/SkipTheMap.vue');
const RydConnectProducts = () =>
  import('@/pages/integrationguide/ryd-connect/payload/RydConnectProducts.vue');
const AndroidAutomotiveOverview = () =>
  import('@/pages/integrationguide/android-automotive/getting-started/Overview.vue');
const AndroidAutomotivePlatformBasics = () =>
  import('@/pages/integrationguide/android-automotive/getting-started/PlatformBasics.vue');
const AndroidAutomotiveIntegrationPathways = () =>
  import('@/pages/integrationguide/android-automotive/getting-started/IntegrationPathways.vue');
const AndroidAutomotiveDriverJourney = () =>
  import('@/pages/integrationguide/android-automotive/in-car/DriverJourney.vue');
const AndroidAutomotiveVehicleIntegration = () =>
  import('@/pages/integrationguide/android-automotive/in-car/VehicleIntegration.vue');
const AndroidAutomotiveAppVariantsAndStores = () =>
  import('@/pages/integrationguide/android-automotive/in-car/AppVariantsAndStores.vue');
const AndroidAutomotiveBestPractices = () =>
  import('@/pages/integrationguide/android-automotive/launch/BestPractices.vue');
const AndroidAutomotiveTesting = () =>
  import('@/pages/integrationguide/android-automotive/launch/Testing.vue');
const AndroidAutomotiveResourcesAndFaq = () =>
  import('@/pages/integrationguide/android-automotive/launch/ResourcesAndFaq.vue');

/** Redirect to a moved page while keeping `#section` deep links and query parameters. */
const keepHash = (path: string) => (to: RouteLocation) => ({
  path,
  hash: to.hash,
  query: to.query,
});

export const integrationGuideRoutes: AppRouteRecordRaw[] = [
  {
    path: '/integration-overview',
    component: Body,
    meta: {
      breadcrumb: 'Integration Guide',
    },
    children: [
      {
        path: '',
        name: 'IntegrationOverview',
        component: IntegrationOverview,
        meta: {
          title: ' Integration Overview | ryd Portal',
          breadcrumb: 'Integration Overview',
        },
      },
    ],
  },
  // Moved to Security & Compliance (ticket 2026-10-19-security-and-compliance-section, D-04);
  // query and #anchor are kept so existing deep links (e.g. #ip-whitelisting) still land.
  {
    path: '/integration-guide/network-and-security',
    redirect: (to) => ({
      path: '/security-and-compliance/network-and-ip-allowlist',
      query: to.query,
      hash: to.hash,
    }),
  },
  {
    path: '/integration-guide/deeplinking-registration',
    component: Body,
    meta: {
      breadcrumb: 'Deeplinking Registration',
    },
    children: [
      {
        path: 'getting-started',
        name: 'deeplinkingRegistrationGettingStarted',
        component: DeeplinkRegistrationApiGettingStarted,
        meta: {
          title: ' Integration Guide: Deeplinking Registration Getting Started | ryd Portal',
          breadcrumb: 'Getting Started',
        },
      },
      {
        path: 'api-reference',
        name: 'deeplinkingRegistrationApiReference',
        component: DeeplinkRegistrationApiReference,
        meta: {
          title: ' Integration Guide: Deeplinking Registration API Reference | ryd Portal',
          breadcrumb: 'API Reference',
        },
      },
      {
        path: 'changelog',
        redirect: '/integration-guide/deeplinking-registration/getting-started',
      },
      {
        path: 'guides-and-tutorials',
        redirect: '/integration-guide/deeplinking-registration/getting-started',
      },
      {
        path: 'faqs',
        redirect: '/integration-guide/deeplinking-registration/getting-started',
      },
    ],
  },
  {
    path: '/integration-guide/webapp-integration',
    component: Body,
    meta: {
      breadcrumb: 'Integration Guide',
    },
    children: [
      {
        path: 'introduction',
        name: 'WebappIntegrationIntroduction',
        component: WebappIntegrationIntroduction,
        meta: {
          title: ' Integration Guide: webapp Integration Introduction | ryd Portal',
          breadcrumb: 'Introduction',
        },
      },
      {
        path: 'getting-started',
        name: 'WebappIntegrationGettingStarted',
        component: WebappIntegrationGettingStarted,
        meta: {
          title: ' Integration Guide: webapp Integration Getting Started | ryd Portal',
          breadcrumb: 'Getting Started',
        },
      },
      {
        path: 'topup-flow-steps',
        name: 'WebappIntegrationTopupFlowSteps',
        component: WebappIntegrationTopupFlowSteps,
        meta: {
          title: ' Integration Guide: Topup Flow Steps | ryd Portal',
          breadcrumb: 'Top-up Flow Steps',
        },
      },
      {
        path: 'guides-and-tutorials',
        redirect: '/integration-guide/webapp-integration/getting-started',
      },
      {
        path: 'faqs',
        redirect: '/integration-guide/webapp-integration/testing',
      },
      {
        path: 'terms-and-definitions',
        redirect: '/integration-guide/webapp-integration/testing',
      },
      {
        path: 'testing',
        name: 'WebappIntegrationTesting',
        component: WebappIntegrationTesting,
        meta: {
          title: ' Integration Guide: webapp Integration Testing | ryd Portal',
          breadcrumb: 'Testing',
        },
      },
      {
        path: 'troubleshooting-and-support',
        redirect: '/integration-guide/webapp-integration/testing',
      },
      {
        path: 'changelog',
        redirect: '/integration-guide/webapp-integration/introduction',
      },
    ],
  },
  {
    path: '/integration-guide/rydsdk',
    component: Body,
    meta: {
      breadcrumb: 'SDK Documentation',
    },
    children: [
      {
        path: 'introduction',
        name: 'sdkIntroduction',
        component: SdkIntroduction,
        meta: {
          title: 'rydsdk | ryd Portal',
          breadcrumb: 'Overview',
        },
      },
      {
        path: 'getting-started',
        name: 'sdkGettingStarted',
        children: [
          {
            path: 'installation',
            name: 'sdkInstallation',
            component: SdkInstallation,
            meta: {
              title: 'SDK Sections Available On Demand | ryd Portal',
              breadcrumb: 'Available On Demand',
            },
          },
          {
            path: 'configuration',
            redirect: '/integration-guide/rydsdk/getting-started/installation',
          },
          {
            path: 'quickstart',
            redirect: '/integration-guide/rydsdk/getting-started/installation',
          },
        ],
      },
      {
        path: 'features',
        name: 'sdkFeatures',
        children: [
          {
            path: 'refueling',
            redirect: '/integration-guide/rydsdk/introduction#service-coverage',
          },
          {
            path: 'carwash',
            redirect: '/integration-guide/rydsdk/introduction#service-coverage',
          },
          {
            path: 'charging',
            redirect: '/integration-guide/rydsdk/introduction#service-coverage',
          },
        ],
      },
      {
        path: 'resources',
        name: 'sdkResources',
        children: [
          {
            path: 'best-practices',
            redirect: '/integration-guide/rydsdk/getting-started/installation#support',
          },
          {
            path: 'faq',
            redirect: '/integration-guide/rydsdk/getting-started/installation#support',
          },
          {
            path: 'changelog',
            redirect: '/integration-guide/rydsdk/getting-started/installation#support',
          },
        ],
      },
    ],
  },
  {
    path: '/integration-guide/rydpay-apis',
    component: Body,
    meta: {
      breadcrumb: 'Integration Guide',
    },
    children: [
      // START legacy links -> don't delete
      {
        path: '',
        name: 'rydPayApis',
        component: TopupApiReference,
        meta: {
          title: ' ryd.pay APIs | ryd Portal',
          breadcrumb: 'ryd.pay APIs',
        },
      },

      {
        path: 'introduction',
        name: 'rydpayApiIntroduction',
        component: RydPayApiGettingStarted,
        meta: {
          title: ' ryd.pay APIs Getting Started | ryd Portal',
          breadcrumb: 'Getting Started',
        },
      },
      {
        path: 'getting-started',
        name: 'rydpayApiGettingStarted',
        component: RydPayApiGettingStarted,
        meta: {
          title: ' rydpay APIs Getting Started | ryd Portal',
          breadcrumb: 'Getting Started',
        },
      },
      {
        path: 'guides',
        name: 'RydPayApiApiFundamentals',
        component: RydPayApiApiFundamentals,
        meta: {
          title: ' Integration Guide: rydpay APIs Guides | ryd Portal',
          breadcrumb: 'API Fundamentals',
        },
      },
      {
        path: 'Tutorials',
        name: 'RydPayApiBestPractices',
        component: RydPayApiBestPractices,
        meta: {
          title: 'rydpay APIs: Best Practices | ryd Portal',
          breadcrumb: 'Best Practices',
        },
      },
      {
        path: 'key-concepts',
        name: 'KeyConcepts',
        component: KeyConcepts,
        meta: {
          title: 'rydpay APIs: Key Concepts | ryd Portal',
          breadcrumb: 'Platform Concepts',
        },
      },

      // Earlier addresses of the two general guides — keep bookmarks and old links working.
      {
        path: 'guides-general/key-concepts',
        redirect: keepHash('/integration-guide/rydpay-apis/key-concepts'),
      },
      {
        path: 'guides-general/places-filtering-guide',
        redirect: keepHash('/integration-guide/rydpay-apis/places-filtering-guide'),
      },
      {
        path: 'places-filtering-guide',
        name: 'PlacesFilteringGuide',
        component: PlacesFilteringGuide,
        meta: {
          title: 'rydpay APIs: Places Filtering Guide | ryd Portal',
          breadcrumb: 'Places Filtering & Sorting Guide',
        },
      },
      // END legacy links -> don't delete

      {
        path: 'integration-pathways',
        name: 'RydPayApiIntegrationPathways',
        component: RydPayApiIntegrationPathways,
        meta: {
          title: ' rydpay APIs Integration Pathways | ryd Portal',
          breadcrumb: 'Integration Pathways',
        },
      },

      {
        path: 'guides-fuelling/prepay-and-postpay',
        name: 'RydPayApiPrepayAndPostpay',
        component: RydPayApiPrepayAndPostpay,
        meta: {
          title: ' Integration Guide: Prepay vs Postpay | ryd Portal',
          breadcrumb: 'Prepay vs Postpay',
        },
      },
      {
        path: 'guides-fuelling/fuelling-client-flow',
        name: 'FuellingClientFlow',
        component: FuellingClientFlow,
        meta: {
          title: ' Integration Guide: Fuelling Client Flow | ryd Portal',
          breadcrumb: 'Fuelling Client Flows',
        },
      },
      {
        path: 'guides-fuelling/fuelling-client-flow-detailed',
        name: 'FuellingClientFlowDetailed',
        component: FuellingClientFlowDetailed,
        meta: {
          title: ' Integration Guide: Fuelling Client Flow (Detailed) | ryd Portal',
          breadcrumb: 'Fuelling Client Flow (Detailed)',
        },
      },
      {
        path: 'guides-fuelling/prepay-and-postpay-2025',
        name: 'PrepayAndPostpayV2025',
        component: RydPayApiPrepayAndPostpayV2025,
        meta: {
          requiresAuth: true,
          title: 'Prepay vs Postpay (Enhanced 2025) | ryd Portal',
          breadcrumb: 'Prepay vs Postpay (Enhanced 2025)',
        },
      },
      {
        path: 'guides-fuelling/fuelling-postman-collection-viewer',
        name: 'FuellingPostmanCollectionViewer',
        component: FuellingPostmanCollectionViewer,
        meta: {
          title: ' Integration Guide: Postman Collection Viewer | ryd Portal',
          breadcrumb: 'Postman Collection Viewer',
        },
      },

      {
        path: 'api-reference',
        name: 'rydpayReference',
        component: TopupApiReference,
        meta: {
          title: ' Integration Guide: ryd.pay APIs API Reference | ryd Portal',
          breadcrumb: 'ryd.pay APIs',
        },
      },
      {
        path: 'webhooks',
        name: 'RydPayWebhooks',
        redirect: { name: 'WebhookGuide' },
        meta: {
          title: 'Webhook Guide | ryd Portal',
          breadcrumb: 'Webhooks',
        },
      },

      // old link for backwartscompability
      {
        path: 'testing-and-simulation',
        name: 'TestingAndSimulationSectionOverviewBackup',
        component: TestingAndSimulation,
        meta: {
          title: 'Testing And Simulation Section Overview | ryd Portal',
          breadcrumb: 'Testing & Simulation',
        },
      },

      {
        path: 'testing-and-simulation/section-overview',
        name: 'TestingAndSimulationSectionOverview',
        component: TestingAndSimulation,
        meta: {
          title: 'Testing And Simulation Section Overview | ryd Portal',
          breadcrumb: 'Testing & Simulation',
        },
      },
      {
        path: 'testing-and-simulation/fuelling-test-scenarios',
        name: 'FuellingTestScenarios',
        component: FuellingTestScenarios,
        meta: {
          title: 'Fuelling Test Scenarios | ryd Portal',
          breadcrumb: 'Fuelling Test Scenarios',
        },
      },
      {
        path: 'testing-and-simulation/fuelling-simulated-stations',
        name: 'FuellingSimulatedStations',
        component: FuellingSimulatedStations,
        meta: {
          title: ' Fuelling Simulated Stations | ryd Portal',
          breadcrumb: 'Fuelling Simulated Stations',
        },
      },
      {
        path: 'testing-and-simulation/car-wash-test-scenarios',
        name: 'CarWashTestScenarios',
        component: CarWashTestScenarios,
        meta: {
          title: ' Car Wash Test Scenarios | ryd Portal',
          breadcrumb: 'Car Wash Test Scenarios',
        },
      },
      {
        path: 'testing-and-simulation/car-wash-simulated-stations',
        name: 'CarWashSimulatedStations',
        component: CarWashSimulatedStations,
        meta: {
          title: ' Car Wash Simulated Stations | ryd Portal',
          breadcrumb: 'Car Wash Simulated Stations',
        },
      },
      {
        path: 'car-wash-client-flow',
        name: 'CarWashClientFlow',
        component: CarWashClientFlow,
        meta: {
          title: ' Car Wash Client Flow | ryd Portal',
          breadcrumb: 'Car Wash Client Flows',
        },
      },
      {
        path: 'car-wash-demo-and-playground',
        name: 'CarWashPlayground',
        component: CarWashPlayground,
        meta: {
          title: ' Car Wash Demo & Playground | ryd Portal',
          breadcrumb: 'Car Wash API Playground',
        },
      },
      {
        path: 'guides-ev-charging/ev-pricing',
        name: 'EvPricing',
        component: EvPricing,
        meta: {
          title: ' EV Pricing | ryd Portal',
          breadcrumb: 'EV Pricing',
        },
      },
      {
        path: 'guides-ev-charging/ev-insights-and-statistics',
        name: 'EvInsightsAndStatistics',
        component: EvInsightsAndStatistics,
        meta: {
          title: ' EV Charging Insights & Statistics | ryd Portal',
          breadcrumb: 'EV Insights & Statistics',
        },
      },
      {
        path: 'guides-ev-charging/api-journey',
        name: 'EVChargingApiJourney',
        component: EVChargingApiJourney,
        meta: {
          title: ' EV Charging API Journey | ryd Portal',
          breadcrumb: 'EV Charging API Journey',
        },
      },
      {
        path: 'testing-and-simulation/ev-charging-test-scenarios',
        name: 'EvChargingTestScenarios',
        component: EvChargingTestScenarios,
        meta: {
          title: ' Ev Charging Test Scenarios | ryd Portal',
          breadcrumb: 'EV Charging Test Scenarios',
        },
      },
      {
        path: 'testing-and-simulation/ev-charging-simulated-stations',
        name: 'EvChargingSimulatedStations',
        component: EvChargingSimulatedStations,
        meta: {
          title: ' Ev Charging Simulated Stations | ryd Portal',
          breadcrumb: 'EV Charging Simulated Stations',
        },
      },
      {
        path: 'test-scenarios',
        name: 'TestingAndSimulation',
        component: TestingAndSimulation,
        meta: {
          title: ' Integration Guide: ryd.pay APIs Test Scenarios | ryd Portal',
          breadcrumb: 'Testing & Simulation',
        },
      },

      {
        path: 'api-fundamentals',
        name: 'RydPayApiApiFundamentals',
        component: RydPayApiApiFundamentals,
        meta: {
          title: 'rydpay APIs: API Fundamentals | ryd Portal',
          breadcrumb: 'API Fundamentals',
        },
      },
      {
        path: 'order-state-management',
        name: 'RydPayApiOrderStateManagement',
        component: RydPayApiOrderStateManagement,
        meta: {
          title: 'rydpay APIs: Order State Management | ryd Portal',
          breadcrumb: 'Order State Management',
        },
      },
      {
        path: 'order-timeouts-and-cancellation',
        name: 'RydPayApiOrderTimeouts',
        component: RydPayApiOrderTimeouts,
        meta: {
          title: 'rydpay APIs: Order Timeouts & Cancellation | ryd Portal',
          breadcrumb: 'Order Timeouts & Cancellation',
        },
      },

      {
        path: 'action-codes',
        name: 'RydPayApiActionCodesOverview',
        component: RydPayApiActionCodesOverview,
        meta: {
          title: 'rydpay APIs: Action Codes Overview | ryd Portal',
          breadcrumb: 'Action Codes',
        },
      },
      {
        path: 'action-codes/search',
        name: 'RydPayApiActionCodesSearch',
        component: RydPayApiActionCodesSearch,
        meta: {
          title: 'rydpay APIs: Action Code Search | ryd Portal',
          breadcrumb: 'Action Code Search',
        },
      },
      {
        path: 'action-codes/pop',
        name: 'RydPayApiActionCodesPop',
        component: RydPayApiActionCodesPop,
        meta: {
          title: 'rydpay APIs: POP Action Codes | ryd Portal',
          breadcrumb: 'POP Action Codes',
        },
      },
      {
        path: 'action-codes/pay',
        name: 'RydPayApiActionCodesPay',
        component: RydPayApiActionCodesPay,
        meta: {
          title: 'rydpay APIs: PAY Action Codes | ryd Portal',
          breadcrumb: 'PAY Action Codes',
        },
      },
      {
        path: 'action-codes/solutions',
        name: 'RydPayApiActionCodesSolutions',
        component: RydPayApiActionCodesSolutions,
        meta: {
          title: 'rydpay APIs: Action Codes — Common Scenarios & Solutions | ryd Portal',
          breadcrumb: 'Action Codes Solutions',
        },
      },
      {
        path: 'partner-wallet',
        name: 'RydPayApiOEMPartnerWalletManagement',
        component: PartnerWalletOverview,
        meta: {
          title: 'rydpay APIs: ryd Partner Driver Wallet Management | ryd Portal',
          breadcrumb: 'Integration Guide',
        },
      },

      {
        path: 'best-practices',
        name: 'RydPayApiBestPractices',
        component: RydPayApiBestPractices,
        meta: {
          title: 'rydpay APIs: Best Practices | ryd Portal',
          breadcrumb: 'Best Practices',
        },
      },

      {
        path: 'faqs',
        name: 'rydpayApiFaqs',
        component: RydPayApiFAQs,
        meta: {
          title: 'FAQs',
          breadcrumb: 'FAQs',
        },
      },

      {
        path: 'troubleshooting-and-support',
        name: 'rydpayApiTroubleshootingAndSupport',
        component: RydPayApiTroubleshootingAndSupport,
        meta: {
          title: 'Troubleshooting & Support',
          breadcrumb: 'Troubleshooting & Support',
        },
      },
      {
        path: 'terms-and-definitions',
        name: 'rydpayApiTermsAndDefinitions',
        component: RydPayApiTermsAndDefinitions,
        meta: {
          title: 'Terms & Definitions',
          breadcrumb: 'Terms & Definitions',
        },
      },

      {
        path: 'release-notes-and-updates',
        name: 'rydpayApiReleaseNotesAndUpdates',
        component: RydPayApiReleaseNotesAndUpdates,
        meta: {
          title: ' Integration Guide: ryd.pay APIs Release Notes and Updates | ryd Portal',
          breadcrumb: 'Release Notes & Updates',
        },
      },
    ],
  },
  {
    path: '/integration-guide/fleet-apis',
    component: Body,
    meta: {
      breadcrumb: 'Integration Guide',
    },
    children: [
      {
        path: 'fleet-api-introduction',
        name: 'FleetApiIntroduction',
        component: FleetApiIntroduction,
        meta: {
          title: 'Fleet API Introduction | ryd Portal',
          breadcrumb: 'Fleet API Introduction',
        },
      },
      {
        path: 'fleet-api-authentication',
        name: 'FleetApiAuthentication',
        component: FleetApiAuthentication,
        meta: {
          title: 'Fleet API Authentication | ryd Portal',
          breadcrumb: 'Fleet API Authentication',
        },
      },
      {
        path: 'fleet-api-reference',
        name: 'FleetApiReference',
        component: FleetApiReference,
        meta: {
          title: 'Fleet API Reference | ryd Portal',
          breadcrumb: 'Fleet API Reference',
        },
      },
      {
        path: 'fleet-api-app-login',
        name: 'FleetApiAppLogin',
        component: FleetApiAppLogin,
        meta: {
          title: 'Login to ryd From Your App | ryd Portal',
          // Not "Login to ryd": the breadcrumb CSS capitalizes every word, which would print "Ryd".
          breadcrumb: 'App Login',
        },
      },
      // Short addresses used by older links (Integration Pathways, API Credentials) — keep them working.
      {
        path: 'introduction',
        redirect: keepHash('/integration-guide/fleet-apis/fleet-api-introduction'),
      },
      {
        path: 'authentication',
        redirect: keepHash('/integration-guide/fleet-apis/fleet-api-authentication'),
      },
      {
        path: 'reference',
        redirect: keepHash('/integration-guide/fleet-apis/fleet-api-reference'),
      },
      { path: '', redirect: '/integration-guide/fleet-apis/fleet-api-introduction' },
    ],
  },
  {
    path: '/integration-guide/ryd-connect',
    component: Body,
    meta: {
      breadcrumb: 'Integration Guide',
    },
    children: [
      {
        path: 'getting-started/overview',
        name: 'RydConnectOverview',
        component: RydConnectOverview,
        meta: {
          title: 'ryd Connect | Getting Started | ryd Portal',
          breadcrumb: 'Getting Started',
        },
      },
      {
        path: 'getting-started/integration-pathways',
        name: 'RydConnectIntegrationPathways',
        component: RydConnectIntegrationPathways,
        meta: {
          title: 'ryd Connect Integration Pathways | ryd Portal',
          breadcrumb: 'Integration Pathways',
        },
      },
      {
        path: 'payload/products',
        name: 'RydConnectProducts',
        component: RydConnectProducts,
        meta: {
          title: 'ryd Connect | Fuel, Car Wash And EV Charging | ryd Portal',
          breadcrumb: 'Fuel, Car Wash And EV Charging',
        },
      },
      {
        path: 'authentication',
        name: 'RydConnectAuthentication',
        component: RydConnectAuthenticationOverview,
        meta: {
          title: 'ryd Connect Authentication Flows | ryd Portal',
          breadcrumb: 'Authentication Flows',
        },
      },
      {
        path: 'authentication/session-token',
        name: 'RydConnectSessionToken',
        component: RydConnectSessionToken,
        meta: {
          title: 'ryd Connect | Session Token Flow | ryd Portal',
          breadcrumb: 'Session Token',
        },
      },
      {
        path: 'authentication/jwt-assertion',
        name: 'RydConnectJwtAssertion',
        component: RydConnectJwtAssertion,
        meta: {
          title: 'ryd Connect | JWT Assertion Flow | ryd Portal',
          breadcrumb: 'JWT Assertion',
        },
      },
      {
        path: 'authentication/one-time-token',
        name: 'RydConnectOneTimeTokenSecurity',
        component: RydConnectOneTimeTokenSecurity,
        meta: {
          title: 'ryd Connect | One-Time Token Security | ryd Portal',
          breadcrumb: 'One-Time Token Security',
        },
      },
      {
        path: 'payload/partner-extra-data',
        name: 'RydConnectPartnerExtraData',
        component: RydConnectPartnerExtraData,
        meta: {
          title: 'ryd Connect | Partner Extra Data | ryd Portal',
          breadcrumb: 'Partner Extra Data',
        },
      },
      {
        path: 'app-integration/callbacks',
        name: 'RydConnectCallbacks',
        component: RydConnectCallbacks,
        meta: {
          title: 'ryd Connect Callbacks | ryd Portal',
          breadcrumb: 'ryd Connect Callbacks',
        },
      },
      {
        path: 'app-integration/theming',
        name: 'RydConnectTheming',
        component: RydConnectTheming,
        meta: {
          title: 'ryd Connect Partner Theming | ryd Portal',
          breadcrumb: 'ryd Connect Partner Theming',
        },
      },
      {
        path: 'testing/guide',
        name: 'RydConnectTesting',
        component: RydConnectTesting,
        meta: {
          title: 'ryd Connect Testing | ryd Portal',
          breadcrumb: 'ryd Connect Testing',
        },
      },
      {
        path: 'getting-started/webview-approaches',
        name: 'RydConnectWebViewApproaches',
        component: RydConnectWebViewApproaches,
        meta: {
          title: 'WebView Integration Approaches | ryd Portal',
          breadcrumb: 'WebView Integration Approaches',
        },
      },
      {
        path: 'testing/simulated-stations',
        name: 'RydConnectSimulatedStations',
        component: RydConnectSimulatedStations,
        meta: {
          title: 'ryd Connect Simulated Stations | ryd Portal',
          breadcrumb: 'Simulated Stations',
        },
      },
      {
        path: 'payload/skip-the-map',
        name: 'RydConnectSkipTheMap',
        component: RydConnectSkipTheMap,
        meta: {
          title: 'ryd Connect | Skip the Map | ryd Portal',
          breadcrumb: 'Skip the Map',
        },
      },
      {
        path: 'testing/developer-resources',
        name: 'RydConnectDeveloperResources',
        component: RydConnectDeveloperResources,
        meta: {
          title: 'ryd Connect Developer Resources | ryd Portal',
          breadcrumb: 'Developer Resources',
        },
      },

      // Pre-2026-10 flat URLs: kept working (bookmarks, partner docs, emails); hash and query survive.
      {
        path: 'overview',
        redirect: keepHash('/integration-guide/ryd-connect/getting-started/overview'),
      },
      {
        path: 'integration-pathways',
        redirect: keepHash('/integration-guide/ryd-connect/getting-started/integration-pathways'),
      },
      {
        path: 'webview-approaches',
        redirect: keepHash('/integration-guide/ryd-connect/getting-started/webview-approaches'),
      },
      { path: 'products', redirect: keepHash('/integration-guide/ryd-connect/payload/products') },
      {
        path: 'partner-extra-data',
        redirect: keepHash('/integration-guide/ryd-connect/payload/partner-extra-data'),
      },
      {
        path: 'skip-the-map',
        redirect: keepHash('/integration-guide/ryd-connect/payload/skip-the-map'),
      },
      {
        path: 'callbacks',
        redirect: keepHash('/integration-guide/ryd-connect/app-integration/callbacks'),
      },
      {
        path: 'theming',
        redirect: keepHash('/integration-guide/ryd-connect/app-integration/theming'),
      },
      { path: 'testing', redirect: keepHash('/integration-guide/ryd-connect/testing/guide') },
      {
        path: 'simulated-stations',
        redirect: keepHash('/integration-guide/ryd-connect/testing/simulated-stations'),
      },
      {
        path: 'developer-resources',
        redirect: keepHash('/integration-guide/ryd-connect/testing/developer-resources'),
      },
      { path: '', redirect: '/integration-guide/ryd-connect/getting-started/overview' },
    ],
  },
  {
    path: '/integration-guide/android-automotive',
    component: Body,
    meta: {
      breadcrumb: 'Integration Guide',
    },
    children: [
      {
        path: 'getting-started/overview',
        name: 'AndroidAutomotiveOverview',
        component: AndroidAutomotiveOverview,
        meta: {
          title: 'Android Automotive OS | Overview | ryd Portal',
          breadcrumb: 'Overview',
        },
      },
      {
        path: 'getting-started/platform-basics',
        name: 'AndroidAutomotivePlatformBasics',
        component: AndroidAutomotivePlatformBasics,
        meta: {
          title: 'Android Automotive OS | Platform Basics | ryd Portal',
          breadcrumb: 'Platform Basics',
        },
      },
      {
        path: 'getting-started/integration-pathways',
        name: 'AndroidAutomotiveIntegrationPathways',
        component: AndroidAutomotiveIntegrationPathways,
        meta: {
          title: 'Android Automotive OS | Integration Pathways | ryd Portal',
          breadcrumb: 'Integration Pathways',
        },
      },
      {
        path: 'in-car/driver-journey',
        name: 'AndroidAutomotiveDriverJourney',
        component: AndroidAutomotiveDriverJourney,
        meta: {
          title: 'Android Automotive OS | Driver Journey | ryd Portal',
          breadcrumb: 'Driver Journey',
        },
      },
      {
        path: 'in-car/vehicle-integration',
        name: 'AndroidAutomotiveVehicleIntegration',
        component: AndroidAutomotiveVehicleIntegration,
        meta: {
          title: 'Android Automotive OS | Vehicle Integration | ryd Portal',
          breadcrumb: 'Vehicle Integration',
        },
      },
      {
        path: 'in-car/app-variants-and-stores',
        name: 'AndroidAutomotiveAppVariantsAndStores',
        component: AndroidAutomotiveAppVariantsAndStores,
        meta: {
          title: 'Android Automotive OS | App Variants & Stores | ryd Portal',
          breadcrumb: 'App Variants & Stores',
        },
      },
      {
        path: 'launch/best-practices',
        name: 'AndroidAutomotiveBestPractices',
        component: AndroidAutomotiveBestPractices,
        meta: {
          title: 'Android Automotive OS | Best Practices | ryd Portal',
          breadcrumb: 'Best Practices',
        },
      },
      {
        path: 'launch/testing',
        name: 'AndroidAutomotiveTesting',
        component: AndroidAutomotiveTesting,
        meta: {
          title: 'Android Automotive OS | Testing & Checklist | ryd Portal',
          breadcrumb: 'Testing & Checklist',
        },
      },
      {
        path: 'launch/resources-and-faq',
        name: 'AndroidAutomotiveResourcesAndFaq',
        component: AndroidAutomotiveResourcesAndFaq,
        meta: {
          title: 'Android Automotive OS | Resources & FAQ | ryd Portal',
          breadcrumb: 'Resources & FAQ',
        },
      },
      { path: '', redirect: '/integration-guide/android-automotive/getting-started/overview' },
    ],
  },
];
